import { Music2, Youtube, ExternalLink, Link as LinkIcon, Headphones } from "lucide-react";

/**
 * Compact grid of streaming-platform deep links for a profile.
 * Accepts a profile object; renders nothing if no platforms are set.
 */
const PLATFORMS = [
  { key: "spotify", label: "Spotify", color: "#1DB954", url: (p) => p.spotify_artist_id ? `https://open.spotify.com/artist/${p.spotify_artist_id}` : p.spotify_album_id ? `https://open.spotify.com/album/${p.spotify_album_id}` : null },
  { key: "apple_music", label: "Apple Music", color: "#FA243C", url: (p) => p.apple_music_url },
  { key: "youtube_music", label: "YT Music", color: "#FF0000", url: (p) => p.youtube_music_url },
  { key: "youtube", label: "YouTube", color: "#FF0000", url: (p) => p.youtube_video_id ? `https://youtu.be/${p.youtube_video_id}` : null },
  { key: "tidal", label: "Tidal", color: "#FFFFFF", url: (p) => p.tidal_url },
  { key: "amazon_music", label: "Amazon Music", color: "#1399FF", url: (p) => p.amazon_music_url },
  { key: "soundcloud", label: "SoundCloud", color: "#FF7700", url: (p) => p.soundcloud_url },
  { key: "bandcamp", label: "Bandcamp", color: "#629AA9", url: (p) => p.bandcamp_url },
  { key: "payhip", label: "Buy / Download", color: "#FFD700", url: (p) => p.payhip_url },
  { key: "unitedmasters", label: "UnitedMasters", color: "#000000", url: (p) => p.unitedmasters_url },
  { key: "linktree", label: "Linktree", color: "#43E660", url: (p) => p.linktree_url },
];

export default function StreamingLinks({ profile }) {
  if (!profile) return null;
  const active = PLATFORMS.map((pl) => ({ ...pl, href: pl.url(profile) })).filter((pl) => pl.href);
  if (active.length === 0) return null;

  return (
    <div className="my-10" data-testid="streaming-links">
      <div className="label text-pfc-gold mb-4 flex items-center gap-2"><Headphones size={14} /> Stream on your favorite platform</div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2.5">
        {active.map((pl) => (
          <a
            key={pl.key}
            href={pl.href}
            target="_blank"
            rel="noreferrer"
            className="group relative border border-white/10 bg-ink-800/40 hover:border-pfc-gold hover:bg-pfc-gold/5 transition px-4 py-3.5 flex items-center justify-between gap-2 overflow-hidden"
            data-testid={`stream-${pl.key}`}
          >
            <span className="absolute left-0 top-0 bottom-0 w-1 transition-all group-hover:w-1.5" style={{ backgroundColor: pl.color }} />
            <span className="font-sub text-sm text-white group-hover:text-pfc-gold transition pl-2">{pl.label}</span>
            <ExternalLink size={12} className="text-white/40 group-hover:text-pfc-gold transition shrink-0" />
          </a>
        ))}
      </div>
    </div>
  );
}
